import styled from 'styled-components';
import { ButtonTag } from '../../components/Button/styles';

export const CalendalModalButton = styled(ButtonTag)`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 0 5px;

  width: 100px;
`;

export const CalendalModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CalendalModalButtonContainer = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
`;

export const CalendalModalHeader = styled.h2`
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.gray};

  width: 100%;

  margin: 0;
  margin-bottom: 10px;
`;

export const CalendalModalMainInfoContainer = styled.p`
  margin: 10px 0;
`;

export const CalendalModalMainInfo = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;

  text-align: center;
  span{
    color: ${({ theme }) => theme.green};
  }
`;

export const CalendalModalText = styled.p`
  margin: 10px 0;
  font-size: 16px;

  text-align: center;
  span{
    font-weight: bold;

    color: ${({ error, theme }) => error ? theme.red : theme.green};
  }
`;
